/**
 * Merges an array of strings into a single string with spaces between each string.
 *
 * @param classNames - An array of strings representing class names.
 * @returns A single string with all class names separated by a space.
 */
export function classes(classNames: string[]): string {
  return classNames.filter(Boolean).join(' ');
}
